import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  SpellLimitation,
  SpellModifier,
  SpellOverrides
} from "@dndModels";

import SpellLimitInput from "@dndComponents/limitations/SpellLimitInput";
import SpellOverridesInput from "@dndComponents/feature/SpellOverridesInput";

interface Props {
  obj: SpellModifier;
  onChange: (changed: SpellModifier) => void; 
  disabled: boolean;
}

export default function SpellModifierInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className='header centered'
        size={{
          xs: 12
        }}>Spell Limitation</Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <SpellLimitInput
          obj={obj.spell_limit}
          disabled={disabled}
          onChange={(changed: SpellLimitation) => {
            const new_obj = obj;
            new_obj.spell_limit = changed.clone();
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        className="header"
        size={{
          xs: 12
        }}>Spell Alterations</Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <SpellOverridesInput
          obj={obj.spell_overrides}
          disabled={disabled}
          onChange={(changed: SpellOverrides) => {
            const new_obj = obj;
            new_obj.spell_overrides = changed.clone();
            onChange(new_obj);
          }}
        />
      </Grid>
    </Grid>
  );
}
